import { ButtonSeverity } from 'primeng/button';
import { TicketPriority } from '../../models/ticket.model';

export type PriorityConfig = Readonly<{
	label: string;
	icon: string;
	severity: ButtonSeverity;
}>;

export const TICKET_PRIORITY_CONFIG: Record<TicketPriority, PriorityConfig> = {
	VERY_LOW: {
		label: 'Molto bassa',
		icon: 'pi pi-angle-double-down',
		severity: 'secondary'
	},
	LOW: {
		label: 'Bassa',
		icon: 'pi pi-angle-down',
		severity: 'info'
	},
	MEDIUM: {
		label: 'Media',
		icon: 'pi pi-equals',
		severity: 'warn'
	},
	HIGH: {
		label: 'Alta',
		icon: 'pi pi-angle-up',
		severity: 'danger'
	},
	URGENT: {
		label: 'Urgente',
		icon: 'pi pi-angle-double-up',
		severity: 'help'
	}
};
